module.exports = __webpack_public_path__ + "img/iwm.0bada894.png";